<template>
  <el-table-column
    :prop="celldata.prop"
    :label="celldata.label"
    :type="celldata.type"
    :width="celldata.width"
    :fixed="celldata.fixed"
    :sortable="celldata.sortable"
    :index="celldata.customIndex"
    :class-name="celldata.className"
    :align="celldata.align"
  >
    <template slot-scope="scope">
      <div
        class="colored"
        :class="`color-${scope.row.StatusColor||'no'}`"
      >
        {{ scope.row.StatusText||'' }}
      </div>
    </template>
  </el-table-column>
</template>
<script>
export default {
  props: {
    celldata: Object
  }
}
</script>
<style lang="sass" scoped>
.colored
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  &.color-success
    color: $mainColor
  &.color-danger
    color: $dangerColor
</style>
